"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/JoinMeetingBtnContent.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);






const JoinMeetingBtnContent = ({ isCamOn, isMicOn }) => {
  if (isCamOn) {
    return (
      _react2.default.createElement(_react2.default.Fragment, null
        , _react2.default.createElement('img', { src: "/assets/icons/video/cam-white.svg", alt: ">", __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}} ), "Join with video"

      )
    )
  }

  if (isMicOn) {
    return (
      _react2.default.createElement(_react2.default.Fragment, null
        , _react2.default.createElement('img', { src: "/assets/icons/video/phone-white.svg", alt: ">", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}} ), "Join with audio only"

      )
    )
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('img', { src: "/assets/icons/video/out-white.svg", alt: ">", __self: this, __source: {fileName: _jsxFileName, lineNumber: 29}} ), "Join the meeting"

    )
  )
}

exports. default = JoinMeetingBtnContent
